<template>
  <div class="content-section">
    <div class="section-header">
      <h2 class="section-title">{{ title }}</h2>
    </div>
    
    <div class="card-grid">
      <!-- 加载中显示骨架屏 -->
      <template v-if="loading">
        <div v-for="i in maxItems" :key="`skeleton-${i}`" class="card-item">
          <card-skeleton />
        </div>
        <div class="card-item">
          <more-card @more-click="$emit('more-click')" />
        </div>
      </template>
      
      <!-- 加载完成显示内容 -->
      <template v-else>
        <div v-for="item in displayItems" :key="item.id" class="card-item" @click="playVideo(item.id)">
          <music-card :image="IMAGE_BASE_URL + item.poster" :title="item.zhName" />
        </div>
        <div class="card-item">
          <more-card @more-click="$emit('more-click')" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import MusicCard from './MusicCard.vue';
import MoreCard from './MoreCard.vue';
import CardSkeleton from './CardSkeleton.vue';
import { IMAGE_BASE_URL } from '../utils/constants';

export default {
  name: 'ContentSection',
  components: {
    MusicCard,
    MoreCard,
    CardSkeleton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    maxItems: {
      type: Number,
      default: 4
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IMAGE_BASE_URL
    };
  },
  computed: {
    displayItems() {
      return this.items.slice(0, this.maxItems);
    }
  },
  methods: {
    playVideo(id) {
      console.log(id,'id');
      this.$emit('play-video', id);
    }
  }
}
</script>

<style scoped>
.content-section {
  margin-bottom: 30px;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
}

@media (max-width: 1200px) {
  .card-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  
  .card-item:last-child {
    display: none;
  }
}

@media (max-width: 992px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style> 